import { Injectable, OnDestroy } from '@angular/core';
import { Observable, of, ReplaySubject, Subscription, tap } from 'rxjs';
import { DiscussionService } from '../discussion/discussion.service';
import { CurrentUser } from "../../common/providers/current-user";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ChatCounterService implements OnDestroy {
  private totalUnseenSubject = new ReplaySubject<number>(1);  // Properly initialize with buffer size 1
  public totalUnseen$ = this.totalUnseenSubject.asObservable();  // Use $ suffix for observables
  private subscription: Subscription = new Subscription();  // Use a single Subscription object

  constructor(
    private discussionService: DiscussionService,
    private currentUserService: CurrentUser
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();  // Unsubscribe from all subscriptions
  }
  public refreshChatCounter(): Observable<any> {
    if (this.currentUserService.user) {
      return this.discussionService.countUnseenMessagesByUser(this.currentUserService.user)
        .pipe(
          tap((count) => {
            this.totalUnseenSubject.next(count);
          }),
          catchError(error => {
            console.error('Failed to count unseen messages', error);
            return of(null); // Handle error and return a neutral observable
          })
        );
    } else {
      return of(null); // Return a neutral observable when user is not available
    }
  }

}
